import * as d3 from 'd3-selection'
import menu from './menu/index.js'
import control from './control/index.js'
import * as dataset from '../dataset.js'
import pointerHandler from './pointer-handler.js'
import * as interactions from './interactions.js'

export default function (selection, opts) {
  selection.each(function (data) {
    // The rich select is inserted directly after the native select
    var p = this.parentNode
      , self = this
      , select = d3.select(p)
                   .selectAll('.select')
                   .filter(function (d) {
                     // Make sure this rich select is the next sibling to the native select
                     return self.nextElementSibling === this
                   })
                   .data([data])
      , enter = select.enter()
                      .select(function () {
                        var n = document.createElement('div')
                        return this.insertBefore(n, self.nextSibling)
                      })
                      .attr('aria-hidden', true) // Screen readers will see native selects
                      .call(function (selection) {
                        selection.each(function () {
                          // So native html labels work as intended
                          if (self.id) {
                            d3.select('label[for=' + self.id + ']')
                              .on('click', pointerHandler(function () {
                                // After the event process finished for the label click, focus on the textarea (input)
                                process.nextTick(function () {
                                  select.selectAll('.select-control textarea').node().focus()
                                })
                              }))
                          }
                        })
                      })

    var ancestors = []
      , _p = p

    while (_p) {
      ancestors.unshift(_p)
      _p = _p.parentNode
    }

    // Remove top level document
    ancestors.shift()

    // Attach the ancestors to the data in case any component needs access to them
    data._ancestors = ancestors

    select = enter.merge(select)

    if (Object.keys(self.dataset).length) {
      for (const [key, value] of Object.entries(dataset.expand(dataset.parse(self)))) {
        select.attr(key, value)
      }
    }

    select.attr('class', '') // Clear it each time, then reassign below
          .classed('select', true)
          .classed(this.className, true)
          .classed('disabled', data.disabled)
          .classed('menu-wrapped', data.attachToWrapper)
          .classed('multiple', data.multiple)
          .classed('single', !data.multiple)
          .classed('filterable', data.filterable)
          .classed('has-active', function (d) {
            return d.multiple && !!data.options.filter(function (o) {
                                                 return o.active
                                               }).length
          })
          .classed('has-menu', function (d) {
            return d.open && (data.menuOptions.length || data.filterSuggestion) && !data.disabled
          })
          .classed('focused', function (d) {
            return d.textareaFocused || d.open
          })
          .call(control)
          .call(menu)

    if (data.open) {
      // Register the mousedown/touchstart handler on the document
      // Both are required because it's on the document, for some reason
      d3.select(document).on('mousedown.select-' + data.id + ' touchstart.select-' + data.id, pointerHandler(function (e) {
        var inMenu = d3.selectAll('.select-menu')
                       .filter(function () {
                         return this && this.contains(e.target)
                       })

        if (inMenu.size()) {
          return // Clicked on a menu item with a select-menu. It will handle it, so don't do anything
        }

        if (!select.node().contains(e.target)) {
          interactions.close(data)
        }
      }), true)
      d3.select(window).on('resize.select-menu-position', interactions.close.bind(null, data))
      d3.selectAll(ancestors)
        .on('scroll.select-scroll', interactions.close.bind(null, data))
    } else {
      d3.select(document).on('mousedown.select-' + data.id + ' touchstart.select-' + data.id, null)
      d3.select(window).on('resize.select-menu-position', null)
      d3.selectAll(ancestors).on('scroll.select-scroll', null)
    }
  })
}
